<ng-template #classic let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="d-flex justify-content-end">
            <span data-dismiss="modal" (click)="closeModal()">
                <i class="material-icons">close</i>
            </span>
        </div>
        <div class="text-center mb-4">
            <span class="modal-title"> {{ 'CHANGE_PASS_MODAL.TITLE' | translate }} </span>
        </div>
        <form role="form" [formGroup]="form" novalidate>
          <div class="form-group">
            <input type="password" class="form-control" placeholder="{{ 'CHANGE_PASS_MODAL.CURRENT_PASSWORD' | translate }}" formControlName="oldPassword">
          </div>
            <div class="form-group">
                <input type="password" class="form-control" placeholder="{{ 'CHANGE_PASS_MODAL.PASSWORD' | translate }}" [ngClass]="{'is-valid': !passControl.invalid, 'is-invalid': passControl.invalid && passControl.touched}" formControlName="password">
                <div class="text-center invalid-feedback" [ngStyle]="{'display': passControl.invalid && passControl.touched ? 'block' : 'none'}">
                    <span> {{ 'CHANGE_PASS_MODAL.INVALID_PASSWORD' | translate }} </span>
                </div>
            </div>
            <div class="form-group">
                <input type="password" class="form-control" placeholder="{{ 'CHANGE_PASS_MODAL.CONFIRM_PASSWORD' | translate }}" [ngClass]="{'is-valid': !confirmPassControl.invalid, 'is-invalid': confirmPassControl.invalid && confirmPassControl.touched}" formControlName="passwordConfirm">
                <div class="text-center invalid-feedback" [ngStyle]="{'display': confirmPassControl.invalid && confirmPassControl.touched ? 'block' : 'none'}">
                    <span> {{ 'CHANGE_PASS_MODAL.INVALID_CONFIRM_PASSWORD' | translate }} </span>
                </div>
            </div>
            <div class="text-center my-3 font-14" *ngIf="confirmPassControl.valid && passControl.valid">
                <span> {{ 'CHANGE_PASS_MODAL.PASS_STRENGTH' | translate }}
                    <span *ngIf="passStrength == 2; else mediumPass" class="text-success"> {{ 'CHANGE_PASS_MODAL.PASS_STRONG' |
                        translate }} </span>
                <ng-template #mediumPass>
                    <span *ngIf="passStrength == 1; else weakPass" class="text-warning"> {{ 'CHANGE_PASS_MODAL.PASS_MEDIUM' | translate }} </span>
                </ng-template>
                  <ng-template #weakPass>
                    <span class="text-danger"> {{ 'CHANGE_PASS_MODAL.PASS_WEAK' | translate }} </span>
                </ng-template>
                </span>
            </div>
        </form>
        <div class="d-flex justify-content-center mt-4">
            <button [disabled]="!form.valid" type="button" class="modal-ok-btn" ngbAutofocus (click)="save()">
                {{ 'CONSTANTS.BTN_SAVE' | translate | uppercase }} </button>
        </div>
    </div>
</ng-template>
